import React from 'react';

const InputRadio = ({ input, placeholder, type, className, beforeInput, afterInput, initvalue, val, min, max, radioName, active, meta: { asyncValidating, touched, error } }) => {
  return (
    <div className="input-radio">
      <div className="" >
        <label className="custom-control custom-radio">
          <input {...input} className="custom-control-input" type="radio" name={radioName} checked={active} value="1" />
          <span className="custom-control-indicator"></span>
          <span className="custom-control-description">active</span>
        </label>
        <label className="custom-control custom-radio">
          <input {...input} className="custom-control-input" type="radio" name={radioName} checked={!active} value="0" />
          <span className="custom-control-indicator"></span>
          <span className="custom-control-description">inactive</span>
        </label>
      </div>
      {touched && error && <div><span className="text-danger">{error}</span></div>}
    </div>
  );
}

export default InputRadio;



// WEBPACK FOOTER //
// ./src/lib/forms/inputRadio.js